// src/actions/mealActions.js

import api from '../utils/api';

export const FETCH_MEALS_SUCCESS = 'FETCH_MEALS_SUCCESS';
export const ADD_MEAL_SUCCESS = 'ADD_MEAL_SUCCESS';
export const UPDATE_MEAL_SUCCESS = 'UPDATE_MEAL_SUCCESS';
export const DELETE_MEAL_SUCCESS = 'DELETE_MEAL_SUCCESS';
export const FETCH_MEALS_BY_DAY_SUCCESS = 'FETCH_MEALS_BY_DAY_SUCCESS';

export const fetchMeals = () => async (dispatch) => {
  try {
    const res = await api.get('/meals');
    dispatch({
      type: FETCH_MEALS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching meals:', error);
  }
};

export const addMeal = (mealData) => async (dispatch) => {
  try {
    const res = await api.post('/meals', mealData);
    dispatch({
      type: ADD_MEAL_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.error('Error adding meal:', error);
    throw error;
  }
};

export const updateMeal = (meal_id, mealData) => async (dispatch) => {
  try {
    const res = await api.put(`/meals/${meal_id}`, mealData);
    dispatch({
      type: UPDATE_MEAL_SUCCESS,
      payload: res.data,
    });
    return res.data;
  } catch (error) {
    console.error('Error updating meal:', error);
    throw error;
  }
};

export const deleteMeal = (meal_id) => async (dispatch) => {
  try {
    await api.delete(`/meals/${meal_id}`);
    dispatch({
      type: DELETE_MEAL_SUCCESS,
      payload: meal_id,
    });
  } catch (error) {
    console.error('Error deleting meal:', error);
  }
};

export const fetchMealsByDay = (dayOfWeek) => async (dispatch) => {
  try {
    const res = await api.get(`/meals?day_of_week=${dayOfWeek}`);
    dispatch({
      type: FETCH_MEALS_BY_DAY_SUCCESS,
      payload: res.data,
    });
    return res.data; // return data so the caller can use it if needed
  } catch (error) {
    console.error('Error fetching meals by day:', error);
    throw error;
  }
};